import AccountFilter from "../widgets/AccountFilter";
import SearchFilter from "../widgets/SearchFilter"

export default function ConfigToolbar(){
    return <div className="toolbar flex middle gap-8">
        <AccountFilter/>
        <SearchFilter/>
    </div>
}